<template>
    <div>
		<!-- Fornecedores do produto --> 
        <div class="modal fade" id="mdfornecedores" tabindex="-1">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-search" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title">Fornecedores do produto</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row"> 
                            <div class="col-md-12">
                                <div class="alert alert-success text-center" style="padding: 5px; background-color: #4250f2; border-color: #4250f2;">
                                    <strong style="font-size: 16px; color: #f3f1f1;">{{ idproduto }} - {{ descricao }}</strong>
                                </div>                                
                            </div>
                            <div class="col-lg-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered table-sm table-hover">
                                        <thead class="thead-light" style="font-weight: 600;">
                                        <tr>
                                            <th>Fornecedor:</th>
                                            <th>Ultima compra:</th>
                                            <th>Nr. NF:</th>
                                            <th>Qtd:</th>
                                            <th>Pr. Compra:</th>
                                            <th>Pr. Custo:</th>
                                            <th>Total:</th>
                                            <th>Filial:</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(fornecedor, index) in lstfornecedoresproduto" v-bind:key="index">
                                                <td style="font-weight: 600;">{{ fornecedor.idfornecedor }} - {{ fornecedor.fantasia }}</td>
                                                <td style="text-align: right;">{{ fornecedor.ultimacompra }}</td>
                                                <td style="font-weight: 600;">{{ fornecedor.numero }}</td>
                                                <td style="text-align: right;">{{ fornecedor.qtditem }}</td>
                                                <td style="text-align: right;">{{ formatavalores(fornecedor.prcompra) }}</td>
                                                <td style="text-align: right; font-weight: 600;">{{ formatavalores(fornecedor.vprcusto) }}</td>
                                                <td style="text-align: right;">{{ formatavalores(parseFloat(fornecedor.qtditem) * parseFloat(fornecedor.vprcusto)) }}</td>
                                                <td style="font-weight: 600;">{{ fornecedor.idfilial }} - {{ fornecedor.fantasiafilial }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>                 
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Sair</button>
                    </div>                          
                </div>
            </div>
        </div>                                   
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpfornecedoresproduto',
    props:[
                'idproduto',
                'descricao'
          ],
    data: function() {
        return {
            lstfornecedoresproduto : []
        };
    },
    methods: {
        formatavalores:function (val) {
            return util.formatarvalor(val, '');
        },       
        mtdfornecedoresproduto(){
            var vself           = this;
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor  : 'fornecedores'},
                {parametro: 'idproduto',    valor  : vself.idproduto}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
            retorno.then(function (response) {
                if (response.data.length === 0){
                    vself.$toastr.i('Não há registros de compras para o produto informado!', 'Informação!');
                }else{
                    vself.lstfornecedoresproduto = [];
                    vself.lstfornecedoresproduto = response.data;
                    $('#mdfornecedores').modal('show');
                }
            }).catch(function (response) {
                vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
            });                
        } 
    },
    mounted: function() {
        let vself = this;
        $("#mdfornecedores").on('shown.bs.modal', function(){
            vself.mtdfornecedoresproduto();
        });
        $("#mdfornecedores").on('hide.bs.modal', function(){
            vself.lstfornecedoresproduto = [];
        });                        
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>
    #mdfornecedores{
        z-index: 2001!important;
    }    
</style>